import Aegis from '@tencent/aegis-web-sdk-v2';
import { getCookieAmend } from './apiUtils';

/**
 * 初始化 Aegis V2 SDK
 * 用于监控页面性能、错误、API调用等数据并上报到伽利略平台
 */
export const initAegis = (): void => {
  try {
    const url = 'https://tgalileo.com/collect'; // 伽利略上报地址
    const id = 'SDK-b48c80f49e2ce11b0020'; // 项目token

    window.AegisV2 = new Aegis({
      id, // 项目token，即上报伽利略监控的唯一标识
      uid: getCookieAmend('guid') || getCookieAmend('vuserid') || '',
      hostUrl: { url },
      plugin: {
        device: true, // 默认开启device收集器
        close: true, // 默认开启close收集器
        aid: true, // 默认开启aid收集器
        fId: false, // 默认关闭fingerId
        ie: false, // 默认关闭ie收集器

        // 页面访问
        pv: true, // 默认开启pv收集器
        spa: true, // 默认开启spa收集器

        // 勾选异常分析
        error: true, // 默认开启error收集器

        // 勾选静态资源监控
        assetSpeed: true, // 默认开启assetSpeed收集器

        // 勾选页面性能
        pagePerformance: true, // 默认开启pagePerformance收集器
        webVitals: true, // 默认开启webVitals收集器
      },
    });

    console.log('✅ Aegis V2 SDK 已初始化');
  } catch (error) {
    console.error('❌ Aegis V2 SDK 初始化失败:', error);
  }
};

// 扩展 Window 接口类型声明
declare global {
  interface Window {
    AegisV2?: Aegis;
  }
}
